import comment from '@/api/eschool/homework-comment-public'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  homework_resource: {},
  total_comment: 0,
  current_page: 1,
  last_page: 1
}

export const getters = {}

export const mutations = {
  RECEIVE_RESOURCES(state, resource) {
    state.total_comment = resource.meta.total
    state.current_page = resource.meta.current_page
    state.last_page = resource.meta.last_page

    state.resources.unshift(
      ...resource.data.sort(function(a, b) {
        return new Date(a.dates) - new Date(b.dates)
      })
    )
  },
  REMOVE_RECORD(state, record) {
    if (record.reference_id) {
      state.resources
        .filter(r => r.id == record.reference_id)
        .forEach(el => {
          el.children.splice(
            el.children.indexOf(...el.children.filter(c => c.id == record.id)),
            1
          )
        })
    } else {
      state.resources.splice(state.resources.indexOf(record), 1)
    }
  },
  PUSH_NEW_RECORD(state, record) {
    if (record.reference_id) {
      state.resources
        .filter(r => r.id == record.reference_id)
        .forEach(el => {
          el.children.push(record)
        })
    } else {
      state.resources.push(record)
    }
  },
  SHOW_REPLY_INPUT_BOX(state, record) {
    if (record.reference_id) {
      state.resources
        .filter(r => r.id == record.reference_id)
        .forEach(el => {
          el.is_reply = true
        })
    } else {
      state.resources
        .filter(r => r.id == record.id)
        .forEach(el => {
          el.is_reply = true
        })
    }
  },
  RESET_STATE(state) {
    state.total_comment = 0
    state.current_page = 1
    state.last_page = 1
    state.resources = []
  }
}

export const actions = {
  fetch(context, id) {
    return comment.get(id)
  },
  store(context, data) {
    return comment.store(data)
  },
  update(context, { id, data }) {
    return comment.update(id, data)
  },
  destroy(context, id) {
    return comment.destroy(id)
  },
  getComment(context, id) {
    return comment
      .getComment(id, {
        params: {
          page:
            context.state.current_page + 1 < context.state.last_page
              ? context.state.current_page + 1
              : context.state.last_page,
          perPage: context.state.pagination.perPage
        }
      })
      .then(response => {
        context.commit('RECEIVE_RESOURCES', response)
        return Promise.resolve(response)
      })
  },
  download(context, options) {
    return comment.download({
      params: options
    })
  }
}
